import { GoodsList } from '../components/GoodsList';

import { useDepartmentStore } from '@/stores/department';

export const GoodsPage = () => {
  const department = useDepartmentStore((state) => state.selected);
  return <GoodsList department={department} />;
};
